export const deleteEducation = ({ BeURL, id, handleTopClear }) => {
    fetch(`${BeURL}/candidate-education-delete/${id}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                alert(data.message)
                handleTopClear()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate education", err)
        })
}
